import { CheckBox } from '@interstate/components/CheckBox';
import { useAcquisitionFeeField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';

import { CompositeValue } from '../../CompositeValue';
import { ScenarioManualEditMarker } from '../../ScenarioManualEditMarker';
import { ScenarioRow } from '../../ScenarioRow';

const UPFRONT_SX = { marginBottom: 0, backgroundColor: 'transparent' };

export const AcqFeeRow = () => {
    const { label, upfrontLabel, overrideIndicatorProps, inputProps, upfrontProps } = useAcquisitionFeeField({
        tab: DealTabs.SUMMARY
    });
    const inputId = useScenarioCellId('acqFee');

    return (
        <ScenarioRow rowKey="acqFee" label={label} inputId={inputId}>
            <CompositeValue
                control={
                    <CheckBox
                        {...upfrontProps}
                        id={`${inputId}-upfront`}
                        data-testid="acq-fee-upfront"
                        label={upfrontLabel}
                        sx={UPFRONT_SX}
                    />
                }
            >
                <ScenarioManualEditMarker {...overrideIndicatorProps}>
                    <NumericInput {...inputProps} id={inputId} displayLabel={false} />
                </ScenarioManualEditMarker>
            </CompositeValue>
        </ScenarioRow>
    );
};
